/*
 * Copyright(c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '@app/authentication/login/login.component';
import { ExamSharingPageComponent } from '@app/di/exam-sharing/exam-sharing-page.component';
import { Shell } from '@app/shell/shell.service';
import { WfmhomecallbackComponent } from '@app/authentication/login/wfmhomecallback.component';

export const routes: Routes = [
  Shell.childRoutes([
    { path: 'login', component: LoginComponent, pathMatch: 'full' },
    { path: 'ui', loadChildren: () => import('./ui/ui.module').then(mod => mod.UiModule) },
    { path: 'shared-exam', component: ExamSharingPageComponent },
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'WFMHome', component: WfmhomecallbackComponent, pathMatch: 'full' },
    { path: '**', redirectTo: '/login' }
  ])
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
